import React, { RefObject, useState } from "react";
import ModalAdd from "../Modals/ModalAdd";
import {
  Box,
  Button,
  HStack,
  Image,
  Input,
  Slider,
  SliderThumb,
  SliderTrack,
  useToast,
  VStack,
  Text
} from "@chakra-ui/react";
import { srcToFile } from "../../Utils";
import { useMutation } from "@apollo/client";
import { Object3D, PerspectiveCamera, Scene } from "three";
import { useAppDispatch, useAppSelector } from "../../Store/hooks";
import {
  setFastMove,
  setAction,
  clearMovingNodes,
} from "../../Store/ConstructorReducer";
import Projects from "../Modals/Projects";
import { GROUPS_QUERY, SAVE_GROUP } from "../Queries";
import {
  ModalsName,
  setCategory,
  setModalOpen,
} from "../../Store/ModalsReducer";
import Images from "../Images/Controls";
import { colors } from "../../Theme";
import { ItemInfo } from "../Modals/ModalAdd/CoveringMaster";
import {
  Action,
  ActionTypes,
  addAction,
} from "../../Store/ActionsHistoryReducer";
import GroupElements from './GroupElements';
import LightSwitcher from './LightSwitcher';

type ControlsProps = {
  saveProject: () => Promise<void>;
  onCenter: Function;
  onMove: Function;
  onFocus: Function;
  onRotate: Function;
  onDelete: Function;
  items: any;
  duplicate: () => void;
  loadObjects: (
    obj: string,
    mtl: string,
    category: string,
    id: number
  ) => Promise<string>;
  scene: Scene | null;
  camera: PerspectiveCamera | null;
  canvasRef: RefObject<HTMLCanvasElement>;
  replaceModel: (
    obj: string,
    mtl: string,
    category: string,
    id: number
  ) => Promise<string>;
  state: {
    offsets: { [key: string]: { x: number; y: number; z: number } };
  };
  intensity: number;
  setIntensity: (intensity: number) => void;
  group: (name: string) => void;
  clearScene: () => void;
  compassRef: RefObject<HTMLDivElement>;
  setColorRecursive: (node: Object3D, color: number) => void;
  addGroup: (id: number) => Promise<void>;
  handleMirror: (axis: "x" | "y" | "z") => void;
  createCovering: (args: {
    model: ItemInfo;
    x: number;
    z: number;
    fill: boolean;
    name: string;
  }) => Promise<string>;
  time: number;
  setTime: (time: number) => void;
  setColor: (color: number) => void;
};

let mover: NodeJS.Timeout | null = null;

const Controls = (props: ControlsProps) => {
  let movingNodes = useAppSelector((state) => state.main.movingNodes);
  const fastMove = useAppSelector((state) => state.main.fastMove);
  const types = useAppSelector((state) => state.main.types);
  const user = useAppSelector((state) => state.global.user);
  const dispatch = useAppDispatch();
  const action = useAppSelector((state) => state.main.action);
  const groups = useAppSelector((state) => state.main.groups);

  const [moveState, setMoveState] = useState({ arrow: "", coef: 1, count: 0 });

  const stopMove = () => {
    console.log("Stop", mover);
    if (mover) {
      console.log("clear");
      clearInterval(mover);
      console.log(moveState);
      let axis: "x" | "y" | "z" = "x";
      let val = 1;
      if (moveState.arrow === "left") {
        axis = "x";
        val *= -1;
      }
      if (moveState.arrow === "right") axis = "x";
      if (moveState.arrow === "up") {
        axis = "z";
        val *= -1;
      }
      if (moveState.arrow === "down") axis = "z";
      if (moveState.arrow === "top") axis = "y";
      if (moveState.arrow === "bottom") {
        axis = "y";
        val *= -1;
      }

      val *= moveState.coef;

      const action: Action = {
        type: ActionTypes.SET_OFFSET,
        data: {
          keys: movingNodes,
          offset: {
            axis,
            distance: val * moveState.count,
          },
        },
      };
      dispatch(addAction(action));

      mover = null;
      dispatch(setAction(""));
    }
  };

  const move = (ev: any) => {
    console.log("start", mover);
    if (!mover) {
      console.log(action, ev.target.dataset.arrow);
      if (action !== ev.target.dataset.arrow) {
        console.log("set");
        dispatch(setAction(ev.target.dataset.arrow));
      }
      let count = 0;
      mover = setInterval(() => {
        let coef = 1;
        if (fastMove) coef = 50;
        props.onMove(ev.target.dataset.arrow, coef);
        count++;
        setMoveState({ arrow: ev.target.dataset.arrow, coef, count });
      }, 50);
      console.log("mover ", mover);
    }
  };

  const [saveGroupMutation, saveGroupInfo] = useMutation(SAVE_GROUP, {
    onError: (error: Error) => {
      toast({ status: "error", title: `Ошибка: ${error.message}` });
    },
    update: (cache, { data }) => {
      // @ts-ignore
      const { groups } = cache.readQuery(GROUPS_QUERY);
      if (groups) {
        const newGroups = [data, ...groups.items];
        cache.writeQuery({
          query: GROUPS_QUERY,
          data: {
            groups: {
              items: newGroups,
            },
          },
        });
      }
    },
  });

  const saveGroup = async () => {
    if (movingNodes.length !== 1) return;
    const tmpMoveNode = movingNodes[0];
    dispatch(clearMovingNodes());
    movingNodes = [];

    const group = groups[tmpMoveNode];

    if (!props.canvasRef || !props.canvasRef.current)
      throw new Error("Canvas not found");
    const file = await srcToFile(
      props.canvasRef.current.toDataURL("image/png"),
      "preview.png",
      "image/png"
    );

    const variables: {
      name: string;
      preview: File;
      ids: number[];
      types: string[];
      offsets: string[];
      rotations: number[];
    } = {
      name: "test",
      preview: file,
      ids: [],
      types: [],
      offsets: [],
      rotations: [],
    };

    for (const key in group.types) {
      variables.ids.push(group.ids[key]);
      variables.types.push(group.types[key]);
      variables.offsets.push(JSON.stringify(group.offsets[key]));
      variables.rotations.push(group.rotations[key]);
    }

    await saveGroupMutation({
      variables,
    });

    toast({ status: "success", title: "Группа сохранена" });
    // props.scene?.traverse((child) => (child.visible = true));
  };

  const toast = useToast({
    position: "top-right",
    status: "success",
    variant: "left-accent",
    isClosable: true,
  });

  const activeImage = { opacity: 0.5 };

  let hasGroupInside = false;

  for (const key of movingNodes) {
    if (types[key] === "group") {
      hasGroupInside = true;
      break;
    }
  }

  return (
    <VStack pos="absolute" right={0} top={0} zIndex={999} p={5} w={160}>
      <VStack w="100%">
        <Box w="130px">
          <label style={{ width: "100%" }}>
            <HStack justify="space-between">
              <Text fontWeight="bold">Утро</Text>
              <LightSwitcher setColor={props.setColor} />
              <Text fontWeight="bold">Вечер</Text>
            </HStack>
            <Slider
              aria-label="Время"
              value={props.time}
              step={3}
              min={-12}
              max={12}
              onChange={(val: number) => props.setTime(val)}
            >
              <SliderTrack />
              <SliderThumb
                bg={colors.brown}
                _focus={{ boxShadow: "none" }}
                w="20px"
                h="10px"
                borderRadius={0}
              />
            </Slider>
          </label>
        </Box>
        <Box w="130px">
          <label style={{ width: "100%" }}>
            <Text align="center" fontWeight="bold">Яркость</Text>
            <Slider
              aria-label="Яркость"
              value={props.intensity}
              step={1}
              min={1}
              max={10}
              onChange={(val: number) => props.setIntensity(val)}
            >
              <SliderTrack />
              <SliderThumb
                bg={colors.brown}
                _focus={{ boxShadow: "none" }}
                w="20px"
                h="10px"
                borderRadius={0}
              />
            </Slider>
          </label>
        </Box>
        <Projects user={user} />
        {user && user.accessLevel >= 100 && (
          <Button
            isFullWidth
            variant="editor"
            onClick={() => window.open("/editor-admin")}
          >
            Админка
          </Button>
        )}
        <ModalAdd
          addGroup={props.addGroup}
          addModel={
            movingNodes.length > 0 ? props.replaceModel : props.loadObjects
          }
          createCovering={props.createCovering}
          canvasRef={props.canvasRef}
        />

        {movingNodes.length === 0 ? (
          <HStack w="100%" justify="center">
            <table>
              <tbody>
                <tr>
                  <td>
                    {Object.keys(props.items).length > 0 && (
                      <Image
                        src={Images.Clean}
                        onClick={props.clearScene}
                        alt="Очистить"
                        title="Очистить"
                        cursor="pointer"
                        w="40px"
                      />
                    )}
                  </td>

                  <td>
                    <Image
                      src={Images.Add}
                      onClick={() =>
                        dispatch(
                          setModalOpen({ key: ModalsName.ADD, value: true })
                        )
                      }
                      cursor="pointer"
                      alt="Добавить"
                      title="Добавить"
                      w="40px"
                    />
                  </td>

                  <td>
                    {Object.keys(props.items).length > 0 && !!user && (
                      <Image
                        src={Images.Save}
                        onClick={() => props.saveProject()}
                        alt="Сохранить"
                        title="Сохранить"
                        w="40px"
                        cursor="pointer"
                      />
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </HStack>
        ) : (
          <VStack w="100%">
            <Box>
              <table>
                <tbody>
                  <tr>
                    <td>
                      {Object.keys(props.items).length > 0 && (
                        <Image
                          src={Images.Clean}
                          onClick={props.clearScene}
                          alt="Очистить"
                          title="Очистить"
                          cursor="pointer"
                          w="40px"
                        />
                      )}
                    </td>
                    <td>
                      <Image
                        src={Images.Top}
                        data-arrow="top"
                        style={action === "top" ? activeImage : {}}
                        onMouseUp={stopMove}
                        onMouseDown={move}
                        cursor="pointer"
                        alt="Переместить вверх"
                        title="Переместить вверх"
                        w="40px"
                      />
                    </td>
                    <td>
                      {Object.keys(props.items).length > 0 && !!user && (
                        <Image
                          src={Images.Save}
                          onClick={() => props.saveProject()}
                          alt="Сохранить"
                          title="Сохранить"
                          cursor="pointer"
                          w="40px"
                        />
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {movingNodes.length === 1 && !hasGroupInside && (
                        <Image
                          src={Images.Replace}
                          alt="Заменить"
                          title="Заменить"
                          cursor="pointer"
                          w="40px"
                          onClick={() => {
                            dispatch(setCategory(types[movingNodes[0]]));
                            dispatch(
                              setModalOpen({ key: ModalsName.ADD, value: true })
                            );
                          }}
                        />
                      )}
                    </td>
                    <td>
                      <Image
                        src={Images.Bottom}
                        data-arrow="bottom"
                        style={action === "bottom" ? activeImage : {}}
                        onMouseUp={stopMove}
                        onMouseDown={move}
                        cursor="pointer"
                        alt="Переместить вниз"
                        title="Переместить вниз"
                        w="40px"
                      />
                    </td>
                    <td>
                      <Image
                        src={Images.Double}
                        onClick={() => props.duplicate()}
                        cursor="pointer"
                        alt="Дублировать"
                        title="Дублировать"
                        w="40px"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Image
                        src={Images.MirrorX}
                        alt="Отразить по X"
                        cursor="pointer"
                        w="40px"
                        bgColor="blue"
                        onClick={() => {
                          const axes: ["x", "z"] = ["x", "z"];
                          // const ind = Math.abs(
                          //   (rotationsGlobal[movingNodes[0]] / 90) % 2
                          // );
                          const ind = 0;
                          props.handleMirror(axes[ind]);
                        }}
                      />
                    </td>
                    <td>
                      <Image
                        src={Images.Delete}
                        onClick={() => {
                          if (window.confirm("Действительно удалить?"))
                            props.onDelete();
                        }}
                        cursor="pointer"
                        alt="Удалить"
                        title="Удалить"
                        w="40px"
                      />
                    </td>
                    <td>
                      <Image
                        src={Images.MirrorZ}
                        alt="Отразить по Z"
                        cursor="pointer"
                        w="40px"
                        bgColor="red"
                        onClick={() => {
                          const axes: ["z", "x"] = ["z", "x"];
                          const ind = 0;
                          // Math.abs(
                          //   (rotationsGlobal[movingNodes[0]] / 90) % 2
                          // );
                          props.handleMirror(axes[ind]);
                        }}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </Box>
            <Box>
              <table>
                <tbody>
                  <tr>
                    <td>
                      <Image
                        src={Images.RotateLeft}
                        onClick={() => props.onRotate(90)}
                        alt="Повернуть против часовой стрелки"
                        title="Повернуть против часовой стрелки"
                        cursor="pointer"
                        w="40px"
                      />
                    </td>
                    <td>
                      <Image
                        src={Images.Up}
                        alt="Подвинуть вперед"
                        title="Подвинуть вперед"
                        data-arrow="up"
                        style={action === "up" ? activeImage : {}}
                        onMouseUp={stopMove}
                        onMouseDown={move}
                        cursor="pointer"
                        w="40px"
                      />
                    </td>
                    <td>
                      <Image
                        src={Images.RotateRight}
                        onClick={() => props.onRotate(-90)}
                        alt="Повернуть по часовой стрелке"
                        title="Повернуть по часовой стрелке"
                        cursor="pointer"
                        w="40px"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Image
                        src={Images.Left}
                        alt="Подвинуть влево"
                        title="Подвинуть влево"
                        data-arrow="left"
                        style={action === "left" ? activeImage : {}}
                        onMouseUp={stopMove}
                        onMouseDown={move}
                        cursor="pointer"
                        w="40px"
                      />
                    </td>
                    <td>
                      <Image
                        src={Images.Focus}
                        alt="Сфокусироваться на элементе"
                        title="Сфокусироваться на элементе"
                        onClick={() => props.onFocus()}
                        cursor="pointer"
                        w="40px"
                      />
                    </td>
                    <td>
                      <Image
                        src={Images.Right}
                        alt="Подвинуть вправо"
                        title="Подвинуть вправо"
                        data-arrow="right"
                        style={action === "right" ? activeImage : {}}
                        onMouseUp={stopMove}
                        onMouseDown={move}
                        cursor="pointer"
                        w="40px"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {!fastMove ? (
                        <Image
                          src={Images.ActiveSlow}
                          alt="Медленное перемещение"
                          title="Медленное перемещение"
                          cursor="pointer"
                          w="40px"
                        />
                      ) : (
                        <Image
                          src={Images.Slow}
                          alt="Медленное перемещение"
                          title="Медленное перемещение"
                          onClick={() => dispatch(setFastMove(false))}
                          cursor="pointer"
                          w="40px"
                        />
                      )}
                    </td>
                    <td>
                      <Image
                        src={Images.Down}
                        alt="Подвинуть назад"
                        title="Подвинуть назад"
                        data-arrow="down"
                        style={action === "down" ? activeImage : {}}
                        onMouseUp={stopMove}
                        onMouseDown={move}
                        cursor="pointer"
                        w="40px"
                      />
                    </td>
                    <td>
                      {fastMove ? (
                        <Image
                          src={Images.ActiveFast}
                          alt="Быстрое перемещение"
                          title="Быстрое перемещение"
                          cursor="pointer"
                          w="40px"
                        />
                      ) : (
                        <Image
                          src={Images.Fast}
                          alt="Быстрое перемещение"
                          title="Быстрое перемещение"
                          onClick={() => dispatch(setFastMove(true))}
                          cursor="pointer"
                          w="40px"
                        />
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </Box>
          </VStack>
        )}
        {movingNodes.length > 1 && !hasGroupInside && (
          <GroupElements handleGroup={props.group} />
        )}
        {false &&
          movingNodes.length === 1 &&
          types[movingNodes[0]] === "group" && (
            <Button
              isFullWidth
              onClick={saveGroup}
              isLoading={saveGroupInfo.loading}
              variant="editor"
            >
              Сохранить группу
            </Button>
          )}
      </VStack>
    </VStack>
  );
};

export default Controls;
